/* src/app/feature-modules/student-list/student-list.component.css */
.search-results {
  height: 10rem;
  overflow: scroll;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
::-webkit-scrollbar-thumb {
  background: rgb(158, 158, 158);
}
::-webkit-scrollbar-thumb:hover {
  background: rgb(158, 158, 158);
}
/*# sourceMappingURL=student-list.component.css.map */
